import { getEnvironment } from "./getEnvironment";

const getDomain = () => {
  const environment = getEnvironment();
  if (environment === "development") {
    return "http://localhost:3000";
  } else if (environment === "staging") {
    return "https://staging.visitwidget.com";
  }

  return "https://visitwidget.com";
};

const getAdminDomain = () => {
  const environment = getEnvironment();
  if (environment === "development") {
    return "http://localhost:31337";
  } else if (environment === "staging") {
    return "https://admin.staging.visitwidget.com";
  }

  return "https://admin.visitwidget.com";
};

export { getDomain, getAdminDomain };
